'use strict'
import { request } from '../../../plugins/http'

export default async (data) => {
    return await request.put(`/statusMensagemAtendimento?id=${data.id}`, {
        factoryUserId: data.factoryUserId, 
        userId: data.userId,
        callMessageId: data.callMessageId
    })
}